import { availableBaseMaps, BaseMapId, BASEMAPS } from '../utils/basemaps'

export default function BaseMapSwitcher({
  value,
  onChange,
  disabled,
}: {
  value: BaseMapId
  onChange: (id: BaseMapId) => void
  disabled?: boolean
}) {
  const options = availableBaseMaps()
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as BaseMapId)}
      title={`Base map: ${BASEMAPS[value].name}`}
      style={{ padding: '0.25rem 0.5rem' }}
      disabled={disabled}
    >
      {options.map(([id, cfg]) => (
        <option key={id} value={id}>
          {cfg.name}
        </option>
      ))}
    </select>
  )
}
